import { ILocationProvider } from 'angular';


export function locationConfig( $locationProvider: ILocationProvider ) {
  $locationProvider.html5Mode({
    enabled: true,
    requireBase: false
  });
}

locationConfig.$inject = [ '$locationProvider' ];



// WEBPACK FOOTER //
// ./app/config/location.config.ts